import { action, makeObservable, observable, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Input } from 'reactstrap';

import './DarkModeToggle.scss';

declare global {
    const ColourMode: {
        DARK: string;
        LIGHT: string;
        toggleColourMode: () => void;
        getCurrentColourMode: () => string;
    };
}

@observer
export class DarkModeToggle extends React.Component {
    @observable
    darkMode = false;

    constructor(props: Record<string, never>) {
        super(props);
        makeObservable(this);
    }

    @action
    toggleDarkMode() {
        ColourMode.toggleColourMode();
        this.darkMode = ColourMode.getCurrentColourMode() === ColourMode.DARK;
    }

    componentDidMount() {
        runInAction(() => {
            this.darkMode = ColourMode.getCurrentColourMode() === ColourMode.DARK;
        });
    }

    render() {
        return (
            <div className="darkModeToggle form-switch" title="Toggle dark mode">
                <i className="icon ion-md-sunny"></i>
                <Input
                    type="checkbox"
                    onChange={() => this.toggleDarkMode()}
                    checked={this.darkMode}
                    role="switch"
                    title="Enable dark mode"
                />
                <i className="icon ion-md-contrast"></i>
            </div>
        );
    }
}
